import { createSlice } from "@reduxjs/toolkit";
import {
  addRole,
  addTemplate,
  addUser,
  assignAlternateRole,
  changePassword,
  deleteRole,
  deleteTemplates,
  deleteUser,
  getAuditLogsRole,
  getAuditLogsUser,
  getFeatures,
  getRoles,
  getTemplate,
  getUsers,
  updateRole,
  updateTemplate,
  updateUser,
  updateUserProfile,
  addAnalyticsGraph,
  updateAnalyticsGraph,
  deleteAnalyticsGraph,
  getAnalyticsGraphs,
  getAlert,
  addAlert,
  updateAlert,
  deleteAlert,
  getAuditLogsAlert,
  addAircraftMasterData,
  getAircraftMaster,
  deleteAircraftMasterData,
  updateAircraftMasterData,
  getSentTriggeredHistoryAlert,
  addEngineMasterData,
  updateEngineMasterData,
  getAircraftFamily,
  addAircraftFamily,
  updateAircraftFamily,
  deleteAircraftFamily,
  getEngineFamily,
  updateEngineFamily,
  deleteEngineFamily,
  addEngineFamily,
  getAircraftTypes,
  getEngineMaster,
  getEngineTypes,
  addEngineType,
  updateEngineTypes,
  deleteEngineTypes,
  deleteEngineMasterData,
  addEngineAndTypes,
  updateEngineAndTypes,
  getAppLookup,
  addIlsMasterData,
  deleteIls,
  getIlsList,
  getVendorQoutesList,
  getAuditLogsTemplate,
  getAuditLogsPricing,
  getAuditLogsSalesEscalation,
  getAuditLogsRepairsEscalation,
  getCashflowLogs,
  addLLPValues,
  updateLLPValues,
  getLLPValues,
  deleteLLPValue,
  getSalesEscalation,
  addSalesEscalation,
  importSalesEscalation,
  updateSalesEscalation,
  deleteSalesEscalation,
  getRepairsEscalation,
  addRepairsEscalation,
  importRepairsEscalation,
  updateRepairsEscalation,
  deleteRepairsEscalation,
  getPartsMasters,
} from "./settingsActions";

export const initialState = {
  isInitialLoad: true,
  rolesInitialLoad: true,
  templateInitialLoad: true,
  graphInitialLoad: true,
  alertInitialLoad: true,
  airFamilyInitialLoad: true,
  engineFamilyInitialLoad: true,
  engineTypeInitialLoad: true,
  masterInitailLoad: true,
  ilsInitialLoad: true,
  loading: false,
  vendorQuotesDataLoading: false,
  addLoading: false,
  formErrors: {},
  features: {},
  users: {},
  roles: {},
  userAuditLogs: {},
  rolesAuditLogs: {},
  templateAuditLogs: {},
  template: {},
  analyticsGraphs: {},
  alert: {},
  alertAuditLogs: {},
  pricingAuditlogs: {},
  escalationAuditLogs: {},
  aircraftMasterData: {},
  engineMasterData: {},
  sentHistoryAlert: {},
  airFamState: {},
  aircraftType: {},
  engineType: {},
  engineFamily: {},
  appLookupInitialLoad: true,
  appLookupData: {},
  ilsData: {},
  vendorQuotesData: {},
  cashflowAuditlogs: {},
  llpValuesList: {},
  llpInitialLoad: true,
  salesEscalationList: {},
  salesEscalationInitialLoad: true,
  repairsEscalationList: {},
  repairsEscalationInitialLoad: true,
  partsMasterData: {},
  partsMasterInitialLoad: {},
};

const settingsSlice = createSlice({
  name: "setting",
  initialState,
  reducers: {
    setInitialLoad: (state, action) => {
      state.isInitialLoad = action.payload;
    },
    setRoleInitalLoad: (state, action) => {
      state.rolesInitialLoad = action.payload;
    },
    setTemplateInitalLoad: (state, action) => {
      state.templateInitialLoad = action.payload;
    },
    setGraphInitialLoad: (state, action) => {
      state.graphInitialLoad = action.payload;
    },
    setAlertInitialLoad: (state, action) => {
      state.alertInitialLoad = action.payload;
    },
    setAirFamilyInitialLoad: (state, action) => {
      state.airFamilyInitialLoad = action.payload;
    },
    setEngineFamilyInialLoad: (state, action) => {
      state.engineFamilyInitialLoad = action.payload;
    },
    setEngineTypeInitialLoad: (state, action) => {
      state.engineTypeInitialLoad = action.payload;
    },
    setMasterInitialLoad: (state, action) => {
      state.masterInitailLoad = action.payload;
    },
    setFormErrors: (state, action) => {
      state.formErrors = action.payload;
    },
    setAppLookpInitialLoad: (state, action) => {
      state.appLookupInitialLoad = action.payload;
    },
    setIlsInitiaLoad: (state, action) => {
      state.ilsInitialLoad = action.payload;
    },
    setLLPValuesInitiaLoad: (state, action) => {
      state.llpInitialLoad = action.payload;
    },
    setSalesEscalationInitialLoad: (state, action) => {
      state.salesEscalationInitialLoad = action.payload;
    },
    setRepairsEscalationInitialLoad: (state, action) => {
      state.repairsEscalationInitialLoad = action.payload;
    },
    setPartsMasterInitialLoad: (state, action) => {
      state.partsMasterInitialLoad = action.payload;
    },
    clearSettingsData: (state) => {
      // state.rolesInitialLoad = true;
      state.loading = false;
      state.addLoading = false;
      state.formErrors = false;
      state.users = {};
      state.roles = {};
      state.features = {};
      state.template = {};
      state.rolesAuditLogs = {};
      state.templateAuditLogs = {};
      state.userAuditLogs = {};
      state.analyticsGraphs = {};
      state.alert = {};
      state.sentHistoryAlert = {};
      state.alertAuditLogs = {};
      state.pricingAuditlogs = {};
      state.escalationAuditLogs = {};
      state.aircraftMasterData = {};
      state.airFamState = {};
      state.aircraftType = {};
      state.engineType = {};
      state.engineMasterData = {};
      state.airFamState = {};
      state.engineFamily = {};
      state.appLookupData = {};
      state.ilsData = {};
      state.vendorQuotesData = {};
      state.cashflowAuditlogs = {};
    },
  },
  extraReducers: (builder) => {
    builder
      // user list
      .addCase(getUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.isInitialLoad = false;
        state.users = action.payload;
      })
      .addCase(getUsers.rejected, (state) => {
        state.loading = false;
        state.isInitialLoad = false;
        state.users = {};
      })
      // rest of the cases remain same
      .addCase(getRoles.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRoles.fulfilled, (state, action) => {
        state.loading = false;
        state.rolesInitialLoad = false;
        state.roles = action.payload;
      })
      .addCase(getRoles.rejected, (state) => {
        state.loading = false;
        state.rolesInitialLoad = false;
        state.roles = {};
      })
      // add new user
      .addCase(addUser.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(addUser.fulfilled, (state) => {
        state.addLoading = false;
      })
      .addCase(addUser.rejected, (state, action) => {
        state.addLoading = false;
        state.formErrors =
          typeof action.payload?.message === String
            ? {}
            : action.payload?.message;
      })
      // update user
      .addCase(updateUser.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateUser.fulfilled, (state) => {
        state.addLoading = false;
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.addLoading = false;
        state.formErrors =
          typeof action.payload?.message === String
            ? {}
            : action.payload?.message;
      })
      // delete user
      .addCase(deleteUser.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(deleteUser.fulfilled, (state) => {
        state.addLoading = false;
      })
      .addCase(deleteUser.rejected, (state) => {
        state.addLoading = false;
      })
      // change user password
      .addCase(changePassword.pending, (state) => {
        state.loading = true;
      })
      .addCase(changePassword.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(changePassword.rejected, (state, action) => {
        state.loading = false;
        state.formErrors =
          typeof action.payload?.message === String
            ? {}
            : action.payload?.message;
      })
      // add role
      .addCase(addRole.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(addRole.fulfilled, (state) => {
        state.addLoading = false;
        state.formErrors = {};
      })
      .addCase(addRole.rejected, (state, action) => {
        state.addLoading = false;
        state.formErrors =
          typeof action.payload?.message === String
            ? {}
            : action.payload?.message;
      })
      // update role
      .addCase(updateRole.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateRole.fulfilled, (state) => {
        state.addLoading = false;
      })
      .addCase(updateRole.rejected, (state, action) => {
        state.addLoading = false;
        state.formErrors =
          typeof action.payload?.message === String
            ? {}
            : action.payload?.message;
      })
      // delete role
      .addCase(deleteRole.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(deleteRole.fulfilled, (state) => {
        state.addLoading = false;
      })
      .addCase(deleteRole.rejected, (state) => {
        state.addLoading = false;
      })
      // assign alternate role
      .addCase(assignAlternateRole.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(assignAlternateRole.fulfilled, (state) => {
        state.addLoading = false;
      })
      .addCase(assignAlternateRole.rejected, (state) => {
        state.addLoading = false;
      })
      // get features
      .addCase(getFeatures.pending, (state) => {
        state.loading = true;
      })
      .addCase(getFeatures.fulfilled, (state, action) => {
        state.loading = false;
        state.features = action.payload;
      })
      .addCase(getFeatures.rejected, (state) => {
        state.loading = false;
      })

      // update user profile
      .addCase(updateUserProfile.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateUserProfile.fulfilled, (state) => {
        state.addLoading = false;
        state.formErrors = {};
      })
      .addCase(updateUserProfile.rejected, (state, action) => {
        state.addLoading = false;
        state.formErrors =
          typeof action.payload?.message === String
            ? {}
            : action.payload?.message;
      })

      // audit Logs users
      .addCase(getAuditLogsUser.pending, (state) => {
        state.loading = true;
        state.userAuditLogs = {};
      })
      .addCase(getAuditLogsUser.fulfilled, (state, action) => {
        state.loading = false;
        state.userAuditLogs = action.payload;
      })
      .addCase(getAuditLogsUser.rejected, (state) => {
        state.loading = false;
      })

      // audit Logs Rols
      .addCase(getAuditLogsRole.pending, (state) => {
        state.loading = true;
        state.rolesAuditLogs = {};
      })
      .addCase(getAuditLogsRole.fulfilled, (state, action) => {
        state.loading = false;
        state.rolesAuditLogs = action.payload;
      })
      .addCase(getAuditLogsRole.rejected, (state) => {
        state.loading = false;
      })

      // audit logs template
      .addCase(getAuditLogsTemplate.pending, (state) => {
        state.loading = true;
        state.templateAuditLogs = {};
      })
      .addCase(getAuditLogsTemplate.fulfilled, (state, action) => {
        state.loading = false;
        state.templateAuditLogs = action.payload;
      })
      .addCase(getAuditLogsTemplate.rejected, (state) => {
        state.loading = false;
      })

      // audit Logs Alerts

      .addCase(getAuditLogsAlert.pending, (state) => {
        state.loading = true;
        state.alertAuditLogs = {};
      })
      .addCase(getAuditLogsAlert.fulfilled, (state, action) => {
        state.loading = false;
        state.alertAuditLogs = action.payload;
      })
      .addCase(getAuditLogsAlert.rejected, (state) => {
        state.loading = false;
      })

      // audit non llp pricing

      .addCase(getAuditLogsPricing.pending, (state) => {
        state.loading = true;
        state.pricingAuditlogs = {};
      })
      .addCase(getAuditLogsPricing.fulfilled, (state, action) => {
        state.loading = false;
        state.pricingAuditlogs = action.payload;
      })
      .addCase(getAuditLogsPricing.rejected, (state) => {
        state.loading = false;
      })

      // audit Logs sales escalation
      .addCase(getAuditLogsSalesEscalation.pending, (state) => {
        state.loading = true;
        state.escalationAuditLogs = {};
      })
      .addCase(getAuditLogsSalesEscalation.fulfilled, (state, action) => {
        state.loading = false;
        state.escalationAuditLogs = action.payload;
      })
      .addCase(getAuditLogsSalesEscalation.rejected, (state) => {
        state.loading = false;
      })

      // audit Logs repairs escalation
      .addCase(getAuditLogsRepairsEscalation.pending, (state) => {
        state.loading = true;
        state.escalationAuditLogs = {};
      })
      .addCase(getAuditLogsRepairsEscalation.fulfilled, (state, action) => {
        state.loading = false;
        state.escalationAuditLogs = action.payload;
      })
      .addCase(getAuditLogsRepairsEscalation.rejected, (state) => {
        state.loading = false;
      })

      // audit Logs cashflow

      .addCase(getCashflowLogs.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCashflowLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.cashflowAuditlogs = action.payload;
      })
      .addCase(getCashflowLogs.rejected, (state) => {
        state.loading = false;
      })

      //get Template

      .addCase(getTemplate.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTemplate.fulfilled, (state, action) => {
        state.loading = false;
        state.templateInitialLoad = false;
        state.template = action.payload;
      })
      .addCase(getTemplate.rejected, (state) => {
        state.loading = false;
        state.templateInitialLoad = false;
        state.template = {};
      })
      // add template
      .addCase(addTemplate.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(addTemplate.fulfilled, (state) => {
        state.addLoading = false;
        state.formErrors = {};
      })
      .addCase(addTemplate.rejected, (state, action) => {
        state.addLoading = false;
        state.formErrors =
          typeof action.payload?.message === String
            ? {}
            : action.payload?.message;
      })
      // update template
      .addCase(updateTemplate.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateTemplate.fulfilled, (state) => {
        state.addLoading = false;
      })
      .addCase(updateTemplate.rejected, (state, action) => {
        state.addLoading = false;
        state.formErrors =
          typeof action.payload?.message === String
            ? {}
            : action.payload?.message;
      })

      // delete tempalte
      .addCase(deleteTemplates.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(deleteTemplates.fulfilled, (state) => {
        state.addLoading = false;
      })
      .addCase(deleteTemplates.rejected, (state, action) => {
        state.addLoading = false;
      })
      // GET GRAPH
      .addCase(getAnalyticsGraphs.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAnalyticsGraphs.fulfilled, (state, action) => {
        state.loading = false;
        state.graphInitialLoad = false;
        state.analyticsGraphs = action.payload;
      })
      .addCase(getAnalyticsGraphs.rejected, (state) => {
        state.graphInitialLoad = false;
        state.analyticsGraphs = {};
      })
      // POST GRAPH
      .addCase(addAnalyticsGraph.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(addAnalyticsGraph.fulfilled, (state) => {
        state.addLoading = false;
        state.formErrors = {};
      })
      .addCase(addAnalyticsGraph.rejected, (state, action) => {
        state.addLoading = false;
        state.formErrors =
          typeof action.payload?.message === String
            ? {}
            : action.payload?.message;
      })
      // PUT GRAPH
      .addCase(updateAnalyticsGraph.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateAnalyticsGraph.fulfilled, (state) => {
        state.addLoading = false;
        state.formErrors = {};
      })
      .addCase(updateAnalyticsGraph.rejected, (state, action) => {
        state.addLoading = false;
        state.formErrors =
          typeof action.payload?.message === String
            ? {}
            : action.payload?.message;
      })
      // DELETE GRAPH
      .addCase(deleteAnalyticsGraph.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(deleteAnalyticsGraph.fulfilled, (state, action) => {
        state.addLoading = false;
        // Remove the deleted graph from the state
        if (state.analyticsGraphs.data) {
          state.analyticsGraphs.data = state.analyticsGraphs.data.filter(
            (graph) => graph.id !== action.meta.arg
          );
        }
      })
      .addCase(deleteAnalyticsGraph.rejected, (state) => {
        state.addLoading = false;
      })
      // Alert GET
      .addCase(getAlert.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAlert.fulfilled, (state, action) => {
        state.loading = false;
        state.alertInitialLoad = false;
        state.alert = action.payload;
      })
      .addCase(getAlert.rejected, (state) => {
        state.loading = false;
        state.alertInitialLoad = false;
        state.alert = {};
      })
      // Alert POST

      .addCase(addAlert.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(addAlert.fulfilled, (state, action) => {
        state.addLoading = false;
        state.formErrors = {};
      })

      .addCase(addAlert.rejected, (state, action) => {
        state.addLoading = false;
        state.formErrors =
          typeof action.payload?.message === String
            ? {}
            : action.payload?.message;
      })

      // Alert PATCH

      .addCase(updateAlert.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateAlert.fulfilled, (state) => {
        state.addLoading = false;
        state.formErrors = {};
      })
      .addCase(updateAlert.rejected, (state, action) => {
        state.addLoading = false;
        state.formErrors =
          typeof action.payload?.message === String
            ? {}
            : action.payload?.message;
      })

      // Alert DELETE
      .addCase(deleteAlert.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(deleteAlert.fulfilled, (state, action) => {
        state.addLoading = false;
      })
      .addCase(deleteAlert.rejected, (state) => {
        state.addLoading = false;
      })
      // Get Sent Alert
      .addCase(getSentTriggeredHistoryAlert.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSentTriggeredHistoryAlert.fulfilled, (state, action) => {
        state.loading = false;
        state.sentHistoryAlert = action.payload || {};
      })
      .addCase(getSentTriggeredHistoryAlert.rejected, (state) => {
        state.loading = false;
        state.sentHistoryAlert = {};
      })

      // Aircraft Family GET:

      .addCase(getAircraftFamily.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAircraftFamily.fulfilled, (state, action) => {
        state.loading = false;
        state.airFamilyInitialLoad = false;
        state.airFamState = action.payload;
      })
      .addCase(getAircraftFamily.rejected, (state) => {
        state.loading = false;
        state.airFamilyInitialLoad = false;
        state.airFamState = {};
      })
      //POST
      .addCase(addAircraftFamily.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(addAircraftFamily.fulfilled, (state, action) => {
        state.addLoading = false;
        state.formErrors = {};
      })

      .addCase(addAircraftFamily.rejected, (state, action) => {
        state.addLoading = false;
        state.formErrors =
          typeof action.payload?.message === String
            ? {}
            : action.payload?.message;
      })
      //Update
      .addCase(updateAircraftFamily.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateAircraftFamily.fulfilled, (state) => {
        state.addLoading = false;
        state.formErrors = {};
      })
      .addCase(updateAircraftFamily.rejected, (state, action) => {
        state.addLoading = false;
        state.formErrors = action.payload?.message || {};
      })
      //Delete
      .addCase(deleteAircraftFamily.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(deleteAircraftFamily.fulfilled, (state) => {
        state.addLoading = false;
      })
      .addCase(deleteAircraftFamily.rejected, (state) => {
        state.addLoading = false;
      })

      // Engine Family

      .addCase(getEngineFamily.pending, (state) => {
        state.loading = true;
      })
      .addCase(getEngineFamily.fulfilled, (state, action) => {
        state.loading = false;
        state.engineFamilyInitialLoad = false;
        state.engineFamily = action.payload;
      })
      .addCase(getEngineFamily.rejected, (state) => {
        state.loading = false;
        state.engineFamilyInitialLoad = false;
        state.engineFamily = {};
      })
      //Create
      .addCase(addEngineFamily.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(addEngineFamily.fulfilled, (state) => {
        state.addLoading = false;
        state.formErrors = {};
      })
      .addCase(addEngineFamily.rejected, (state, action) => {
        state.addLoading = false;
        state.formErrors =
          typeof action.payload?.message === String
            ? {}
            : action.payload?.message;
      })
      // Update
      .addCase(updateEngineFamily.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateEngineFamily.fulfilled, (state) => {
        state.addLoading = false;
        state.formErrors = {};
      })
      .addCase(updateEngineFamily.rejected, (state, action) => {
        state.addLoading = false;
        state.formErrors = action.payload?.message || {};
      })
      //Delete

      .addCase(deleteEngineFamily.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(deleteEngineFamily.fulfilled, (state) => {
        state.addLoading = false;
      })
      .addCase(deleteEngineFamily.rejected, (state) => {
        state.addLoading = false;
      })
      // Aircraft Types

      .addCase(getAircraftTypes.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAircraftTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.isInitialLoad = false;
        state.aircraftType = action.payload;
      })
      .addCase(getAircraftTypes.rejected, (state) => {
        state.loading = false;
        state.isInitialLoad = false;
        state.aircraftType = {};
      })

      // add aircraft master data
      .addCase(addAircraftMasterData.pending, (state) => {
        state.addLoading = true;
        state.loading = true;
      })
      .addCase(addAircraftMasterData.fulfilled, (state) => {
        state.addLoading = false;
        state.loading = false;
      })
      .addCase(addAircraftMasterData.rejected, (state, action) => {
        state.addLoading = false;
        state.loading = false;
        state.formErrors =
          typeof action.payload?.message === String
            ? {}
            : action.payload?.message;
      })

      // update aircraft master data
      .addCase(updateAircraftMasterData.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateAircraftMasterData.fulfilled, (state) => {
        state.addLoading = false;
        state.formErrors = {};
      })
      .addCase(updateAircraftMasterData.rejected, (state, action) => {
        state.addLoading = false;
        state.formErrors =
          typeof action.payload?.message === String
            ? {}
            : action.payload?.message;
      })

      //Engine Types

      .addCase(getEngineTypes.pending, (state) => {
        state.loading = true;
      })
      .addCase(getEngineTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.engineTypeInitialLoad = false;
        state.engineType = action.payload;
      })
      .addCase(getEngineTypes.rejected, (state) => {
        state.loading = false;
        state.engineTypeInitialLoad = false;
        state.engineType = {};
      })
      // POST
      .addCase(addEngineType.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(addEngineType.fulfilled, (state) => {
        state.addLoading = false;
        state.formErrors = {};
      })
      .addCase(addEngineType.rejected, (state, action) => {
        state.addLoading = false;
        state.formErrors =
          typeof action.payload?.message === String
            ? {}
            : action.payload?.message;
      })
      // PATCH
      .addCase(updateEngineTypes.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateEngineTypes.fulfilled, (state) => {
        state.addLoading = false;
        state.formErrors = {};
      })
      .addCase(updateEngineTypes.rejected, (state, action) => {
        state.addLoading = false;
        state.formErrors = action.payload?.message || {};
      })

      // DELETE

      .addCase(deleteEngineTypes.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(deleteEngineTypes.fulfilled, (state) => {
        state.addLoading = false;
      })
      .addCase(deleteEngineTypes.rejected, (state) => {
        state.addLoading = false;
      })

      .addCase(addEngineAndTypes.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(addEngineAndTypes.fulfilled, (state, action) => {
        state.addLoading = false;
        state.formErrors = {};
      })

      .addCase(addEngineAndTypes.rejected, (state, action) => {
        state.addLoading = false;
        state.formErrors =
          typeof action.payload?.message === String
            ? {}
            : action.payload?.message;
      })
      // PATCH

      .addCase(updateEngineAndTypes.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateEngineAndTypes.fulfilled, (state) => {
        state.addLoading = false;
        state.formErrors = {};
      })
      .addCase(updateEngineAndTypes.rejected, (state, action) => {
        state.addLoading = false;
        state.formErrors = action.payload?.message || {};
      })

      // aircraft masterdata list
      .addCase(getAircraftMaster.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAircraftMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.masterInitailLoad = false;
        state.aircraftMasterData = action.payload;
      })
      .addCase(getAircraftMaster.rejected, (state) => {
        state.loading = false;
        state.masterInitailLoad = false;
        state.aircraftMasterData = {};
      })

      // delete master data record
      .addCase(deleteAircraftMasterData.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(deleteAircraftMasterData.fulfilled, (state, action) => {
        state.addLoading = false;
      })
      .addCase(deleteAircraftMasterData.rejected, (state) => {
        state.addLoading = false;
      })

      // add engine master data
      .addCase(addEngineMasterData.pending, (state) => {
        state.addLoading = true;
        state.loading = true;
      })
      .addCase(addEngineMasterData.fulfilled, (state) => {
        state.addLoading = false;
        state.loading = false;
      })
      .addCase(addEngineMasterData.rejected, (state, action) => {
        state.addLoading = false;
        state.loading = false;
        state.formErrors =
          typeof action.payload?.message === String
            ? {}
            : action.payload?.message;
      })

      // update engine master data
      .addCase(updateEngineMasterData.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateEngineMasterData.fulfilled, (state) => {
        state.addLoading = false;
        state.formErrors = {};
      })
      .addCase(updateEngineMasterData.rejected, (state, action) => {
        state.addLoading = false;
        state.formErrors =
          typeof action.payload?.message === String
            ? {}
            : action.payload?.message;
      })
      // get engine master
      .addCase(getEngineMaster.pending, (state) => {
        state.loading = true;
      })
      .addCase(getEngineMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.masterInitailLoad = false;
        state.engineMasterData = action.payload;
      })
      .addCase(getEngineMaster.rejected, (state) => {
        state.loading = false;
        state.masterInitailLoad = false;
        state.engineMasterData = {};
      })
      // delete master data record
      .addCase(deleteEngineMasterData.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(deleteEngineMasterData.fulfilled, (state, action) => {
        state.addLoading = false;
      })
      .addCase(deleteEngineMasterData.rejected, (state) => {
        state.addLoading = false;
      })
      // list app lookup
      .addCase(getAppLookup.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAppLookup.fulfilled, (state, action) => {
        state.loading = false;
        state.appLookupInitialLoad = false;
        state.appLookupData = action.payload;
      })
      .addCase(getAppLookup.rejected, (state) => {
        state.loading = false;
        state.appLookupInitialLoad = false;
        state.appLookupData = {};
      })
      // ils list
      .addCase(getIlsList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getIlsList.fulfilled, (state, action) => {
        state.loading = false;
        state.ilsInitialLoad = false;
        state.ilsData = action.payload;
      })
      .addCase(getIlsList.rejected, (state) => {
        state.loading = false;
        state.ilsInitialLoad = false;
        state.ilsData = {};
      })
      // vendor quotes list
      .addCase(getVendorQoutesList.pending, (state) => {
        state.vendorQuotesDataLoading = true;
      })
      .addCase(getVendorQoutesList.fulfilled, (state, action) => {
        state.vendorQuotesDataLoading = false;
        state.ilsInitialLoad = false;
        state.ilsData = action.payload;
      })
      .addCase(getVendorQoutesList.rejected, (state) => {
        state.vendorQuotesDataLoading = false;
        state.ilsInitialLoad = false;
        state.ilsData = {};
      })
      // add ILS master data
      .addCase(addIlsMasterData.pending, (state) => {
        state.addLoading = true;
        state.loading = true;
      })
      .addCase(addIlsMasterData.fulfilled, (state) => {
        state.addLoading = false;
        state.loading = false;
      })
      .addCase(addIlsMasterData.rejected, (state, action) => {
        state.addLoading = false;
        state.loading = false;
      })
      // delete ils record
      .addCase(deleteIls.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(deleteIls.fulfilled, (state, action) => {
        state.addLoading = false;
      })
      .addCase(deleteIls.rejected, (state) => {
        state.addLoading = false;
      })
      // llp values list
      .addCase(getLLPValues.pending, (state) => {
        state.loading = true;
      })
      .addCase(getLLPValues.fulfilled, (state, action) => {
        state.loading = false;
        state.llpInitialLoad = false;
        state.llpValuesList = action.payload;
      })
      .addCase(getLLPValues.rejected, (state) => {
        state.loading = false;
        state.llpInitialLoad = false;
        state.llpValuesList = {};
      })
      // add llp values
      .addCase(addLLPValues.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(addLLPValues.fulfilled, (state) => {
        state.addLoading = false;
      })
      .addCase(addLLPValues.rejected, (state, action) => {
        state.addLoading = false;
        state.formErrors =
          typeof action.payload?.message === String
            ? {}
            : action.payload?.message;
      })
      // update llp values
      .addCase(updateLLPValues.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateLLPValues.fulfilled, (state) => {
        state.addLoading = false;
      })
      .addCase(updateLLPValues.rejected, (state, action) => {
        state.addLoading = false;
        state.formErrors =
          typeof action.payload?.message === String
            ? {}
            : action.payload?.message;
      })
      // delete LLP values
      .addCase(deleteLLPValue.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(deleteLLPValue.fulfilled, (state, action) => {
        state.addLoading = false;
      })
      .addCase(deleteLLPValue.rejected, (state) => {
        state.addLoading = false;
      })
      // sales escalation list
      .addCase(getSalesEscalation.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSalesEscalation.fulfilled, (state, action) => {
        state.loading = false;
        state.salesEscalationInitialLoad = false;
        state.salesEscalationList = action.payload;
      })
      .addCase(getSalesEscalation.rejected, (state) => {
        state.loading = false;
        state.salesEscalationInitialLoad = false;
        state.salesEscalationList = {};
      })
      .addCase(addSalesEscalation.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(addSalesEscalation.fulfilled, (state) => {
        state.addLoading = false;
      })
      .addCase(addSalesEscalation.rejected, (state, action) => {
        state.addLoading = false;
        state.formErrors =
          typeof action.payload?.message === String
            ? {}
            : action.payload?.message;
      })
      .addCase(importSalesEscalation.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(importSalesEscalation.fulfilled, (state) => {
        state.addLoading = false;
      })
      .addCase(importSalesEscalation.rejected, (state, action) => {
        state.addLoading = false;
        state.formErrors =
          typeof action.payload?.message === String
            ? {}
            : action.payload?.message;
      })
      .addCase(updateSalesEscalation.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateSalesEscalation.fulfilled, (state) => {
        state.addLoading = false;
      })
      .addCase(updateSalesEscalation.rejected, (state, action) => {
        state.addLoading = false;
        state.formErrors =
          typeof action.payload?.message === String
            ? {}
            : action.payload?.message;
      })
      .addCase(deleteSalesEscalation.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(deleteSalesEscalation.fulfilled, (state) => {
        state.addLoading = false;
      })
      .addCase(deleteSalesEscalation.rejected, (state) => {
        state.addLoading = false;
      })
      // repairs escalation list
      .addCase(getRepairsEscalation.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRepairsEscalation.fulfilled, (state, action) => {
        state.loading = false;
        state.repairsEscalationInitialLoad = false;
        state.repairsEscalationList = action.payload;
      })
      .addCase(getRepairsEscalation.rejected, (state) => {
        state.loading = false;
        state.repairsEscalationInitialLoad = false;
        state.repairsEscalationList = {};
      })
      .addCase(addRepairsEscalation.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(addRepairsEscalation.fulfilled, (state) => {
        state.addLoading = false;
      })
      .addCase(addRepairsEscalation.rejected, (state, action) => {
        state.addLoading = false;
        state.formErrors =
          typeof action.payload?.message === String
            ? {}
            : action.payload?.message;
      })
      .addCase(importRepairsEscalation.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(importRepairsEscalation.fulfilled, (state) => {
        state.addLoading = false;
      })
      .addCase(importRepairsEscalation.rejected, (state, action) => {
        state.addLoading = false;
        state.formErrors =
          typeof action.payload?.message === String
            ? {}
            : action.payload?.message;
      })
      .addCase(updateRepairsEscalation.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateRepairsEscalation.fulfilled, (state) => {
        state.addLoading = false;
      })
      .addCase(updateRepairsEscalation.rejected, (state, action) => {
        state.addLoading = false;
        state.formErrors =
          typeof action.payload?.message === String
            ? {}
            : action.payload?.message;
      })
      .addCase(deleteRepairsEscalation.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(deleteRepairsEscalation.fulfilled, (state) => {
        state.addLoading = false;
      })
      .addCase(deleteRepairsEscalation.rejected, (state) => {
        state.addLoading = false;
      })
      // Parts masters list
      .addCase(getPartsMasters.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPartsMasters.fulfilled, (state, action) => {
        state.loading = false;
        state.partsMasterInitialLoad = false;
        state.partsMasterData = action.payload;
      })
      .addCase(getPartsMasters.rejected, (state) => {
        state.loading = false;
        state.partsMasterInitialLoad = false;
        state.partsMasterData = {};
      });
  },
});

export const {
  setInitialLoad,
  setRoleInitalLoad,
  setGraphInitialLoad,
  setAlertInitialLoad,
  setAirFamilyInitialLoad,
  setEngineFamilyInialLoad,
  setEngineTypeInitialLoad,
  clearSettingsData,
  setMasterInitialLoad,
  setFormErrors,
  setAppLookpInitialLoad,
  setIlsInitiaLoad,
  setTemplateInitalLoad,
  setLLPValuesInitiaLoad,
  setSalesEscalationInitialLoad,
  setRepairsEscalationInitialLoad,
  setPartsMasterInitialLoad,
} = settingsSlice.actions;
export default settingsSlice.reducer;
